<template>
  <BaseCard
    title="Reporting Preferences"
    :step-component="'ReportingPreferencesStep'"
  >
    <v-row>
      <v-col cols="12" class="pb-0">
        Receive Reports Via: {{ reportTypes }}
      </v-col>
      <v-col cols="12" class="pb-0" v-if="reportLayouts.length">
        Report Layouts: {{ reportLayouts }}
      </v-col>
      <v-col cols="12" class="pb-0">
        Language:
        {{ getById("locales", selectedClient.locale_code, "code").name }}
      </v-col>
      <v-col cols="12" class="pb-0">
        Units: {{ getById("unit_types", selectedClient.unit_type_id).name }}
      </v-col>
      <v-col cols="12" class="pb-0">
        Hold Report for Entire Package:
        {{ selectedClient.release_full_package ? "Yes" : "No" }}
      </v-col>
      <v-col cols="12" class="pb-0">
        Merge Reports by Farm Name:
        {{ selectedClient.merge_reports_by_farm ? "Yes" : "No" }}
      </v-col>
      <v-col cols="12" class="pb-0" v-if="reportTemplates.length">
        Reports: {{ reportTemplates }}
      </v-col>
      <v-col cols="12" v-if="reportTemplateTypes.length">
        Specialty Reports: {{ reportTemplateTypes }}
      </v-col>
    </v-row>
  </BaseCard>
</template>

<script>
import BaseCard from "@/components/registration/ReviewStepCards/BaseCard";
import { mapGetters, mapState, mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  name: "ReportingPreferences",
  components: { BaseCard },
  computed: {
    ...mapState("clients", [
      "report_communication_types_selected",
      "report_layouts_selected",
      "report_templates_selected",
      "report_template_types_selected"
    ]),
    ...mapState("clients", { clients: "items" }),
    ...mapGetters("clients", ["selectedClient"]),
    ...mapFields("clients", ["client"]),
    ...mapGetters("baseData", ["getById", "report_template_types"]),
    reportTypes() {
      return this.selectedClient.report_communication_types
        .map(type => type.name)
        .filter(name => !!name)
        .join(" ,");
    },
    reportLayouts() {
      const titles = this.report_layouts_selected.map(id => {
        const layout = this.getById("report_layouts", id);
        return layout?.title || null;
      });

      if (titles.some(title => title === null)) {
        return "Loading...";
      }

      return titles.join(", ");
    },
    reportTemplates() {
      return (
        this.report_templates_selected
          .reduce((output, type) => {
            output +=
              (this.getById("report_templates", type) || {}).title + ", " || "";
            return output;
          }, "")
          // Trim whitespace
          .trim()
          // Trim commas
          .replace(/(^,)|(,$)/g, "")
      );
    },
    reportTemplateTypes() {
      return (
        this.report_template_types_selected
          .filter(item =>
            this.report_template_types.find(
              report_template_type => report_template_type.id == item
            )
          )
          .reduce((output, type) => {
            output +=
              (this.getById("report_template_types", type) || {}).name + ", " ||
              "";
            return output;
          }, "")
          // Trim whitespace
          .trim()
          // Trim commas
          .replace(/(^,)|(,$)/g, "")
      );
    }
  },
  watch: {
    "selectedClient.report_communication_types": {
      immediate: true,
      handler(newVal) {
        if (!Array.isArray(newVal) || newVal.length === 0) {
          this.reportTypes = "Loading...";
          return;
        }

        this.reportTypes = newVal
          .map(type => type?.name)
          .filter(Boolean)
          .join(", ");
      }
    },
    selectedClient(newVal) {
      this.client = newVal;
      this.report_communication_types_selected = this.selectedClient?.report_communication_types.map(
        item => item.id
      );
    }
  },
  methods: {
    ...mapActions("clients", ["getClients"])
  },
  async mounted() {
    await this.getClients();

    const updatedClient = this.clients.find(
      client => client.id === this.selectedClient?.id
    );
    if (updatedClient) {
      this.client = updatedClient;
    }
  }
};
</script>

<style scoped></style>
